import { z } from 'zod';
import { LabourWorkload } from './labourWorkLoad';
import { Periodicity } from './periodicity';

export const TaskSchema = z
  .object({
    taskName: z.string().min(1, { message: 'error_field_required' }).max(255, {
      message: `error.field_max_lengh_255`,
    }),
    businessAreaId: z.coerce
      .number({ required_error: 'error_field_required' })
      .min(1, { message: 'error_field_required' }),
    workflowId: z.coerce.number().optional(),
    taskDescription: z.string().optional(),
    taskPeriodicity: z.nativeEnum(Periodicity),
    labourWorkload: z.coerce
      .string()
      .transform((val) => val.replace(',', '.'))
      .pipe(
        z.coerce
          .number({
            message: 'validation.must_be_a_number',
          })
          .positive()
          .refine(
            (n) => {
              const parts = n.toString().split('.');
              return parts.length === 1 || parts[1].length <= 2;
            },
            { message: 'Number must have at most 2 decimal' },
          ),
      ),
    labourWorkloadType: z.nativeEnum(LabourWorkload),
    documentation: z.any().optional(),
    averageCases: z.coerce.number().optional(),
  })
  .refine(
    (data) =>
      data.labourWorkloadType !== LabourWorkload.PerCase ||
      data.averageCases !== 0,
    {
      message: 'Average Cases is required when Labour Workload Type is PerCase',
      path: ['averageCases'],
    },
  );

export type FormTaskSchemaType = z.infer<typeof TaskSchema>;

export interface TaskSchemaType extends FormTaskSchemaType {
  id?: number;
}

export type TaskFormHiddenField =
  | 'organizationId'
  | 'companyId'
  | 'businessAreaId'
  | 'workflowId'
  | 'labourWorkloadType'
  | 'taskPeriodicity';
